import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=4ad38b8e&scoped=true&"
import script from "./sort.vue?vue&type=script&lang=ts&"
export * from "./sort.vue?vue&type=script&lang=ts&"
import style0 from "./sort.vue?vue&type=style&index=0&id=4ad38b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad38b8e",
  null
  
)

export default component.exports